import { object, string, number } from 'yup'
import { AuthResponse } from './auth.types'

export const TokenSchema = object<AuthResponse>().shape({
  access_token: string().required('ACCESS TOKEN not found in the response'),
  scope: string(),
  expires_in: number(),
})
